import React, { useState } from 'react';
import {
  Box,
  FlexBox,
  IconFontAwesome,
  TextDense
} from '@directsoftware/ui-kit-web-admin';
import { Link } from 'react-router-dom';
import {
  buildAddress,
  buildDetailsLink,
  renderFeatures,
  renderName
} from '../listings/resources/shared-functions';

const ListingInfo = ({ stateObject }) => {
  const imageUrl =
    stateObject.featured_image?.image?.small?.url ||
    stateObject.featured_image?.url;
  const [failedImageUrl, setFailedImageUrl] = useState(null);

  return (
    <FlexBox gap="s">
      <FlexBox flexShrink="0">
        <Link to={buildDetailsLink(stateObject)}>
          {imageUrl && imageUrl !== failedImageUrl ? (
            <img
              src={imageUrl}
              alt=""
              className="checkout__listingInfo_img"
              onError={() => setFailedImageUrl(imageUrl)}
            />
          ) : (
            <FlexBox className="checkout__listingInfo_img">
              <IconFontAwesome name="image" />
            </FlexBox>
          )}
        </Link>
      </FlexBox>
      <FlexBox flexDirection="column">
        <Box flex="1">
          <Link to={buildDetailsLink(stateObject)}>
            <TextDense isFullWidth textColor="dark-gray" weight="semibold">
              {renderName(stateObject)}
            </TextDense>
          </Link>
          <TextDense>{buildAddress(stateObject.location)}</TextDense>
        </Box>
        {renderFeatures(stateObject)}
      </FlexBox>
    </FlexBox>
  );
};

export default ListingInfo;
